// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const MarkdownIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="MarkdownIcon" ref={forwardedRef} {...props}>
      <path d="m13.853 13.278-2.603-2.603.865-.865 1.115 1.116V7.02h1.25v3.902l1.115-1.113.865.865z" />
      <path d="M4.274 6.98v6.3h1.17V8.355l1.179 3.78h1.584l1.188-3.798v4.941h1.215v-6.3H8.72l-1.287 4.158-1.26-4.158z" />
      <path d="M1.5 4.5a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1zm1.25 10.75h14.5V4.75H2.75z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const MarkdownIcon = /* @__PURE__ */ Object.assign(
  MarkdownIconComponent,
  { displayName: 'MarkdownIcon' },
);
